export interface IGroup {
    id: number;
    name: string;
    activeUntilDate?: Date;
}

const newGroup = (): IGroup => ({
    id: 0,
    name: '',
})

export const createGroup = <T extends Partial<IGroup>>(initialValues: T): IGroup & T => {
    return Object.assign(newGroup(), initialValues);
};